module.exports = __webpack_public_path__ + "img/promo-hover.f785420f.svg";